import { request } from "@/plugins/axios";
import qs from 'qs';


//评价管理 -------页面接口


// 评价列表
export async function commentList(parmas) {
    return await request({
        url: '/api/u_c/commentList',
        method: 'post',
        data:qs.stringify(parmas)
    })
}
// 评价列表回复
export async function reply(parmas) {
    return await request({
        url: '/api/u_c/reply',
        method: 'post',
        data:qs.stringify(parmas)
    })
}